import './src/scss/style.scss';
require.context('./src/js/', true, /\.(js)$/im);
